import { render, staticRenderFns } from "./StudentIntake.vue?vue&type=template&id=b3bcaaa6"
import script from "./StudentIntake.vue?vue&type=script&lang=js"
export * from "./StudentIntake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports